import { ObjectStorageFileCategory, ObjectStorageFileType, uploadToStorageModel } from '@/models/storage.model';
import { uploadToStorage } from '@/services/storage.service';
import React, { useEffect, useState } from 'react';
import { MdClose } from 'react-icons/md';
import { Form, IconButton } from 'rsuite';

interface FileUploaderProps {
    category: ObjectStorageFileCategory,
    type: ObjectStorageFileType,
    objectUrl?: string,
    onChange : (url: string | undefined) => void;
}
const FileUploader : React.FC<FileUploaderProps>= ({ category, type, objectUrl, onChange }) => {
  const [url, setUrl] = useState(objectUrl);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(()=> {
  setUrl(objectUrl);
  },[objectUrl]);
  
  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setUploading(true);
    setError(null);

    try {
      const model: uploadToStorageModel = {
        file,
        category,
        type
      };
      const uploadedUrl = await uploadToStorage(model);
      setUrl(uploadedUrl);
      if (onChange) onChange(uploadedUrl);
    } catch (err) {
      console.error(err);
      setError('Upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  };
  const handleClearFile = () => {
    setUrl(undefined);
    if (onChange) onChange(undefined);
    setError(null);
  };
  return (
    <div style={{ border: '1px solid #ccc', padding: '16px', borderRadius: '8px' }}>
        <div style={{paddingBottom:10}}>
            <input
                type="file"
                onChange={handleFileChange}
                disabled={uploading}
            />
        </div>
        {uploading && <Form.HelpText>Uploading...</Form.HelpText>}
        {error && <Form.HelpText style={{ color: 'red' }}>{error}</Form.HelpText>}

        {url && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <IconButton
                    icon={<MdClose />}
                    size="xs"
                    onClick={handleClearFile}
                    appearance="subtle"
                    title="Clear file"
                />
                <a href={url} target="_blank" rel="noopener noreferrer">
                    {url}
                </a>
            </div>
        )}
    </div>
  );
};

export default FileUploader;